<template>
  <div id="oie-container">
    <div id="oie-editor">
      <appMargintotal></appMargintotal>
      <appLoadingEditor></appLoadingEditor>
      <appCanvasEditor></appCanvasEditor>
      <appEditorToolbar></appEditorToolbar>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "pinia";

import Margintotal from "../imageEditor/Margintotal";
import LoadingEditor from "../imageEditor/LoadingEditor";
import CanvasEditor from "../imageEditor/CanvasEditor";
import EditorToolbar from "../imageEditor/EditorToolbar";

import { useImageEditorStore } from "@/stores/modules/imageEditor";

export default {
  components: {
    appMargintotal: Margintotal,
    appLoadingEditor: LoadingEditor,
    appCanvasEditor: CanvasEditor,
    appEditorToolbar: EditorToolbar
  },
  methods: {
    ...mapActions(useImageEditorStore, [
      "initFormatPep",
      "initSteckDosenClicks"
    ])
  },
  mounted: function () {
    this.initFormatPep();
    this.initSteckDosenClicks();
  }
};
</script>
